import { render, staticRenderFns } from "./TopupSelectionView.vue?vue&type=template&id=5f1580bb&"
import script from "./TopupSelectionView.vue?vue&type=script&lang=ts&"
export * from "./TopupSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./TopupSelectionView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1580bb')) {
      api.createRecord('5f1580bb', component.options)
    } else {
      api.reload('5f1580bb', component.options)
    }
    module.hot.accept("./TopupSelectionView.vue?vue&type=template&id=5f1580bb&", function () {
      api.rerender('5f1580bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TopupSelectionView.vue"
export default component.exports